module.exports = __webpack_public_path__ + "static/media/iconView.7d5c2bfd.svg";